import React from "react";
import { motion } from "framer-motion";
import MasterclassForm from "./MasterclassForm";

export default function Hero() {
  return (
    <section
      id="top"
      className="section-light relative min-h-screen pt-24 md:pt-32 pb-20 overflow-hidden"
      data-testid="hero"
    >
      <div className="absolute inset-0 pointer-events-none z-0">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 90% 60% at 80% 0%, rgba(199,170,120,0.10), transparent 55%), radial-gradient(ellipse 60% 40% at 10% 100%, rgba(11,14,19,0.04), transparent 60%)",
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10 lg:gap-16 items-start">
          {/* MOBILE ORDER: copy-top (order 1) → form (order 2) → copy-bottom (order 3)
              DESKTOP ORDER: copy-column [top+bottom] on the left, form on the right */}

          {/* Copy TOP (eyebrow + title + subtitle) — visible above the fold on all sizes */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="order-1 lg:order-none lg:col-span-7 lg:row-start-1"
          >
            <div
              className="inline-flex items-center gap-3 px-3 py-1.5 md:px-4 md:py-2 border border-[#C7AA78]/60 bg-[#C7AA78]/8 rounded-full mb-5 md:mb-8 max-w-full"
              data-testid="hero-overline"
            >
              <span className="h-2 w-2 rounded-full bg-[#C7AA78] animate-pulse shrink-0" />
              <span className="text-[#8E7A55] text-[9.5px] md:text-[11px] font-medium tracking-[0.20em] md:tracking-[0.22em] uppercase leading-tight">
                Masterclass gratuita · En directo · Próxima fecha muy pronto
              </span>
            </div>

            <h1
              className="font-serif font-normal text-[#0B0E13] text-[2rem] sm:text-4xl md:text-5xl lg:text-[4.25rem] leading-[1.05] tracking-[-0.015em]"
              data-testid="hero-title"
            >
              Hay decisiones de tu vida
              <br className="hidden sm:block" />
              {" "}que las está tomando{" "}
              <span className="italic text-[#6E7580]">alguien de siete años.</span>
            </h1>

            <p
              className="mt-5 md:mt-7 text-base sm:text-lg md:text-xl text-[#2A303A] max-w-2xl leading-[1.5] md:leading-[1.55] font-light font-sans"
              data-testid="hero-subtitle"
            >
              Aprendiste a protegerte cuando eras muy pequeño. Aquella forma de estar en el
              mundo te funcionó, y se quedó. Hoy sigue eligiendo por ti en tu trabajo, en tu
              dinero y en tus relaciones.
            </p>
          </motion.div>

          {/* Form — mobile: order 2 (immediately below subtitle) · desktop: right column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.15 }}
            className="order-2 lg:order-none lg:col-span-5 lg:row-span-2 lg:row-start-1"
            id="reservar-hero"
          >
            <MasterclassForm variant="hero" observeViewContent={true} />
          </motion.div>

          {/* Copy BOTTOM (highlighted line) — mobile: after form · desktop: below subtitle */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.25 }}
            className="order-3 lg:order-none lg:col-span-7 lg:row-start-2 mt-4 lg:mt-0"
          >
            <p
              className="font-serif italic text-[#0B0E13] text-xl sm:text-2xl md:text-3xl leading-[1.3] tracking-[-0.005em]"
              data-testid="hero-highlight"
            >
              En la próxima masterclass, en directo, vas a ponerle nombre.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
